import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://the-strength-movement.com";

export const SEO_MAP = {
  "/": {
    title: "The Strength Movement | Women's Strength Coach Melbourne",
    description:
      "Evidence-based strength, food freedom and mindset coaching for women, in Melbourne and online across Australia. Build strength, train with confidence, trust your body.",
  },
  "/science": {
    title: "The Science | Evidence-Based Strength Coaching",
    description:
      "How Kim's Bachelor of Exercise and Sport Science shapes individualised programming, technique coaching and body understanding at The Strength Movement.",
  },
  "/psychology": {
    title: "The Psychology | Food, Body Image & Confidence Coaching",
    description:
      "Strength coaching informed by eating disorder psychology. Work through food rules, body image and confidence without rigid dieting or shame.",
  },
  "/coaching": {
    title: "Coaching Options | Online Strength Coaching Australia",
    description:
      "BUILD Coaching (hybrid, $100/week) and BUILD Online ($85/week): sustainable strength and nutrition coaching for women, in Melbourne and online across Australia.",
  },
  "/mentorship": {
    title: "Movement Mentorship for PTs | Personal Trainer Mentorship Melbourne",
    description:
      "Mentorship for PT students and developing coaches, in partnership with AIPT. Certificate facilitation, real coaching experience and ongoing support after you qualify.",
  },
  "/about": {
    title: "About Kim | The Strength Movement",
    description:
      "Meet Kim, founder and head coach of The Strength Movement. Bachelor of Exercise and Sport Science, informed by eating disorder psychology.",
  },
  "/contact": {
    title: "Contact | Book a Free Chat with Kim",
    description:
      "Book a free 30-minute chat or send an enquiry about strength coaching, food freedom coaching or PT mentorship at The Strength Movement.",
  },
  "/privacy": {
    title: "Privacy Policy | The Strength Movement",
    description:
      "How The Strength Movement collects, uses and protects your information.",
  },
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SeoManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = SEO_MAP[pathname] || SEO_MAP["/"];
    document.title = meta.title;
    setMeta("name", "description", meta.description);
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.description);
    setMeta("property", "og:url", `${BASE}${pathname}`);
    setMeta("name", "twitter:title", meta.title);
    setMeta("name", "twitter:description", meta.description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${BASE}${pathname === "/" ? "/" : pathname}`;
  }, [pathname]);
  return null;
};
